
const useStyles = theme => ({
    horizonalContainer: {
      position: 'relative'
    },
    rightArrow: {
      overflow: 'hidden',
      position: 'absolute',
      // Image height is 240, there's 10 paddingTop, and the entire button container
      // has 70 height.
      top: 120 + 10 - 35,
      right: 0,
      alignSelf: 'center',
      alignItems: 'center',
      width: 60,
      height: 70,
      paddingRight: 10,
      [theme.breakpoints.only('md')]: {
        // Image height is 320, there's 10 paddingTop, and the entire button container
        // has 70 height.
        top: 160 + 10 - 35,
      },
      [theme.breakpoints.down('sm')]: {
        visibility: 'hidden'
      }
    },
    leftArrow: {
      overflow: 'hidden',
      position: 'absolute',
      // Image height is 240, there's 10 paddingTop, and the entire button container
      // has 70 height.
      top: 120 + 10 - 35,
      left: 0,
      alignSelf: 'center',
      alignItems: 'center',
      width: 60,
      height:70,
      paddingRight: 10,
      [theme.breakpoints.only('md')]: {
        // Image height is 320, there's 10 paddingTop, and the entire button container
        // has 70 height.
        top: 160 + 10 - 35,
      },
      [theme.breakpoints.down('sm')]: {
        visibility: 'hidden'
      }
    },
    arrowIconButton: {
      height: 70,
      width: 60,
      "&:hover": {
        backgroundColor: 'inherit !important'
      }
    },
});

export default useStyles
